module.exports = __webpack_public_path__ + "static/elementalist_wall-b36104f4f5d2684e13a71627574d6c14.jpg";